import axios from 'axios'
import router from '../router'

/*
|--------------------------------------------------------------------------
| Axios Base config
|--------------------------------------------------------------------------
|
*/
var vueAppPublicToken =
    process.env.VUE_APP_STANDALONE == 'true'
        ? process.env.VUE_APP_PUBLIC_TOKEN
        : document.getElementById('app').getAttribute('publictoken') ||
          process.env.VUE_APP_PUBLIC_TOKEN
var vueAppBackendUrl =
    process.env.VUE_APP_STANDALONE == 'true'
        ? process.env.VUE_APP_BACKEND_URL
        : document.getElementById('app').getAttribute('vueappbackendurl') ||
          process.env.VUE_APP_BACKEND_URL

axios.defaults.baseURL = `${vueAppBackendUrl}/public/${vueAppPublicToken}/api`

/*
|--------------------------------------------------------------------------
| Axios Request Interceptor
|--------------------------------------------------------------------------
|
*/
axios.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('token')

        if (token) config.headers['Authorization'] = `Bearer ${token}`

        return config
    },

    (error) => {
        return Promise.reject(error)
    }
)

/*
|--------------------------------------------------------------------------
| Axios Response Interceptor
|--------------------------------------------------------------------------
|
*/
axios.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        if (error.response.status && error.response.status === 401) {
            localStorage.removeItem('token')
            router.push('/')
        }
        if (error.response.status && error.response.status === 404) {
            router.push('/404')
        }
        return Promise.reject(error)
    }
)

export default axios
